import React from 'react';
import { Sidebar } from './Sidebar';
import type { StudioSession } from '../../data/teamAccess';
interface AppShellProps {
  children: React.ReactNode;
  session: StudioSession;
  onSignOut: () => void;
}
export function AppShell({
  children,
  session,
  onSignOut
}: AppShellProps) {
  return <div className="flex h-full w-full bg-ink-950 text-zinc-100" data-id="element-468" data-mp="3g1o6mauj63u1">
      <Sidebar session={session} onSignOut={onSignOut} data-id="element-469" data-mp="3g3hf7vopey4o" />
      <main className="relative flex-1 overflow-y-auto" data-id="element-470" data-mp="gkpxhbezc8hv">
        <div className="mx-auto w-full max-w-[1200px] px-5 py-7 sm:px-8 sm:py-10 pb-28" data-id="element-471" data-mp="cko5xv2ykvgb">
          {children}
        </div>
      </main>
    </div>;
}